import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { Layout } from 'components/Layout'
import { PointCardCodeEditTemplate } from 'components/Templates'

const PointCardCodeCreate: FC = () => {
  const pathname = useSelector((state: State) => state.router.location.pathname)
  const isEdit = /^\/point_card\/code\/(?!create$)[^/]+$/.test(pathname)

  return (
    <Layout iconPath={'/icon/white/point_card.svg'} headline={'QRコード'} title={'QRコード'}>
      <PointCardCodeEditTemplate isEdit={isEdit} />
    </Layout>
  )
}

export default PointCardCodeCreate
